define.alias("shared/components/shared/ui/education", "media/components/shared/ui/education");